import { NavigationGuard } from 'vue-router';

import { IS_MOBILE_APP_QUERY, USER_LOGIN_KEYCLOAK } from '@gig/magic-messages';
import { magic } from '@gig/magic-sdk';
export const IS_ACCOUNT_VERIFIED = 'is-account-verified';

export const keycloakLoginGuard: NavigationGuard = async (_to, from, next) => {
    if (magic.session.getUser()) {
        next(false);
        return;
    }

    const isMobileApp = await window.queryBus.query(IS_MOBILE_APP_QUERY);
    if (isMobileApp) {
        await window.commandBus.publish(USER_LOGIN_KEYCLOAK, {
            url: _to.query?.backTo ?? _to.fullPath ?? window.location.href,
        });

        next(false);
        return;
    }

    const backToLink =
        typeof _to.query.backTo === 'string' ? _to.query.backTo : '';

    const accountVerified = localStorage.getItem(IS_ACCOUNT_VERIFIED) === '1';
    if (accountVerified) {
        localStorage.removeItem(IS_ACCOUNT_VERIFIED);
        // for newly created users we redirect to the home page
        // so it is correctly recognised as the first navigation
        // and redirect the user to the navigation page only for the first time
        await window.commandBus.publish(USER_LOGIN_KEYCLOAK, {
            url: window.location.origin + backToLink,
            params: {
                accountVerified: true,
            },
        });
    } else {
        await window.commandBus.publish(USER_LOGIN_KEYCLOAK, {
            url: window.location.origin + backToLink,
        });
    }

    next(false);
};
